export const CHAPTER_SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/ieeecisuj/',
  linkedin: 'https://www.linkedin.com/search/results/all/?keywords=ieee%20computational%20intelligence%20society%20university%20of%20jordan%20student%20chapter&origin=RICH_QUERY_SUGGESTION&spellCorrectionEnabled=false&heroEntityKey=urn%3Ali%3Aorganization%3A86790747&position=0',
  facebook: 'https://www.facebook.com/IEEE.CIS.JU?rdid=Q1yHzWUpmDL54BQ0&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1DcU5hLLgy%2F#',
};
